
import React, { useState, useEffect ,useRef} from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import UIInput from 'components/input/input';
import Button from 'components/buttons/';
import UIDatePicker from "components/datepicker";
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISelect from 'components/selectbox/UISelect';
import codeDataStore from "common/codedata/store/CodeDataStore";
import { CodeData } from "common/codedata/source/CodeDataSource";
import StringUtil from "utils/StringUtil";
import paramStore from "common/page/store/ParamStore";
/* 환수신청*/
function ContentsContainer() {
	const location = useLocation();
	let receivedData = (location.state as any)?.data;
  	const history = useHistory();
	
  	const [StartDate, setStartDate] = useState(() => {
    const currentYear = new Date().getFullYear();
    	return new Date(currentYear, 0, 1);
  	});

	const [dateNum,setDateNum] = useState(0); //날짜 기본값	
	const [EndDate, setEndDate] = useState(new Date());
	const [totalRowCnt, setTotalRowCnt] = useState(0);
	const [showRowCnt, setShowRowCnt] = useState(20); //기본 row count
	const [SUB_YN, setSUB_YN] = useState('');
	const [BIZ_CD, setBIZ_CD] = useState('');
	const [BIZ_SHORT_NM, setBIZ_SHORT_NM] = useState<CodeData[]>();
	const [REDE_REQ_STS_CD, SetREDE_REQ_STS_CD] = useState('');

	//검색조건 
	const [REDE_COMPL_YN, setREDE_COMPL_YN] = useState('');  //환수완료여부
	const [TSK_NM, setTSK_NM] = useState('');   //과제명
	const [PERSON_NM, setPERSON_NM] = useState(''); //담당자명 
	const [redeReqStsCd, setRedeReqStsCd] = useState('');  //진행상태 
	
    let SheetData = {};
   
	//검색조건 저장용
	let searchParams = useRef<any>({});
	let pageNum = useRef<number>(1);
	let searchType = useRef<String>('');

	/**ibsheet 세팅  */
    //초기 데이터 설정
	let totalCnt = useRef<number>(0);
	let defaultRowCnt = 20;
	let rowCnt = useRef<number>(20);

	var ib = {
		//시트 초기화 구문
		'init':{
			"Def": {
				"Header": {
				  "Visible": 1
				},
				"Row": {
				  "CanFormula": 1,
				  "AlternateColor": "#CCDDE4"
				}
			},
			"Cfg": {
				"SearchMode": 1,
				"PageLength": showRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0"         		
			},
			"Cols": [
	            {"Header": "NO","Type": "Int",	"Name": "SEQ",	"RelWidth": "0.5","Align": "Center","CanEdit": 0},
				{"Header": "제출여부" ,"Type": "Enum","Name": "SUB_YN","RelWidth": 0.7,"Align": "Center","CanEdit": 0,"Enum": "|제출|미제출","EnumKeys": "|Y|N"},
	            {
					"Header": "진행상태",
	            	"Type": "Html",
	            	"Name": "REDE_REQ_STS_CD",
	            	"RelWidth": 0.7,
	            	"Align": "center",
	            	"CanEdit": "0", 
	            	"Format": {
						'A':'<label class="badge badge-22 blue">신청</label>',
						'B':'<label class="badge badge-22 skyblue">접수중</label>',
						'C':'<label class="badge badge-22 yellow">수정요청</label>',
						'D':'<label class="badge badge-22 red">반려</label>',
						'F':'<label class="badge badge-22 green">최종접수</label>',
						'E':'<label class="badge badge-22 gray">입금확인</label>',	
						'H':'<label class="badge badge-22 gray">지출결의중</label>',	
						'G':'<label class="badge badge-22 black">환수완료</label>',
											
					}, 
	            },
	            {"Header": "과제명","Type": "Text",	"Name": "TSK_NM","RelWidth": 2,	"Align": "left","TextStyle": 4,"CanEdit": 0},
	            {"Header": "출연기업명","Type": "Text",	"Name": "CORP_NM",	"RelWidth": 1,	"Align": "left",	"CanEdit": 0},
	            {"Header": "담당자","Type": "Text",	"Name": "REDE_REQ_USERNM","RelWidth": 0.5,	"Align": "Center",	"CanEdit": 0},
				{"Header": "환수신청일시","Type": "Date","Name": "REDE_REQ_DATE","RelWidth": 1.5,"Align": "Center","CanEdit": "0", Format: "yyyy-MM-dd HH:mm:ss", DataFormat: "yyyy-MM-dd HH:mm:ss"},
	            {"Header": "집행금액","Type": "Int","Name": "PAY_AMT",	"RelWidth": 1,	"Align": "Right",	"CanEdit": 0},
				{"Header": "환수신청금액","Type": "Int","Name": "REDE_AMT",	"RelWidth": 1,	"Align": "Right",	"CanEdit": 0},
				{"Header": "입금금액", "Type": "Int","Name": "TRD_AMT",	"RelWidth": 1,	"Align": "Right",	"CanEdit": 0},
				{"Header": "미환수금액","Type": "Int","Name": "UN_REDE_AMT","Formula": minusFormula,"RelWidth": 1},
	            {"Header": "면제금액",	"Type": "Int",	"Name": "EXEMP_AMT","RelWidth": 1,"Align":"Right","CanEdit": 0},
				{"Header": "환수완료여부" ,"Type": "Enum","Name": "CLO_YN","RelWidth": 0.5,"Formula": redeEndFormula,"Align": "Center","CanEdit": 0,"Enum": "|예|아니오","EnumKeys": "|Y|N"},
	            {"Header": "TSK_REQ_NO","Type": "Text",	"Name": "TSK_REQ_NO","RelWidth": 0,	Visible : 0},
	            {"Header": "PAY_REQ_NO","Type": "Text",	"Name": "PAY_REQ_NO","RelWidth": 0,	Visible : 0},
				{"Header": "REDE_REQ_NO","Type": "Text","Name": "REDE_REQ_NO","RelWidth": 0, Visible : 0}
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				if(receivedData == undefined){
					//초기 데이터 로딩
					onClickSearch('init','');
				}else{
					if(searchType.current == 'M' || receivedData.searchPageType == 'M'){ //기본보기가 아닐경우 	
						if(JSON.stringify(receivedData.searchData) =='{}'){
							onClickSearch('init', '');
						}else{
							onClickSearch('search' , receivedData.searchData);
						}
					}else{
						if(JSON.stringify(receivedData.searchData) =='{}'){
							onClickSearch('init','');
						}else{
							onClickSearch('search' , receivedData.searchData);
						}
					}
				}
			},
			onRenderPageFinish : function(evtParam){
				if(receivedData !=undefined ){
					if(receivedData.searchPageNum != undefined && searchType.current == ''){  //페이지 번호가 있으면 모든 렌더링이 끝나고 다시 페이지 이동처리
						pageMove(receivedData.searchPageNum);
					}
				}
			},
			//시트 클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					if(evtParam.col == "TSK_NM" ){
						var sheet = evtParam.sheet;
						var row = sheet.getFocusedRow();
						sheet.selectRow( row, 1);
						var vREDE_REQ_NO = row["REDE_REQ_NO"];
						var vPAY_REQ_NO = row["PAY_REQ_NO"];
						var vTSK_REQ_NO = row["TSK_REQ_NO"];
						var vTSK_REQ_MODI_SEQ = row["TSK_REQ_MODI_SEQ"];
						
						let searchData = searchParams.current;
						if(JSON.stringify(searchData) == '{}'){
							if(receivedData != undefined){
								searchData = receivedData.searchData;
							}
						}

						let searchPageNum = pageNum.current;
						let searchPageType = searchType.current;
						let searchPageRowCnt = rowCnt.current;
						let dataToSend = {
							searchData , searchPageNum, searchPageType, searchPageRowCnt,vREDE_REQ_NO, vPAY_REQ_NO, vTSK_REQ_NO, vTSK_REQ_MODI_SEQ
						}
						paramStore.setParam("adm1501", dataToSend);
						// 다른 페이지로 이동하면서 데이터 전달
						history.push({
							pathname: './adm1501',
							state: { data: dataToSend }
						});
						
					}
				}

		    },	
			
			
			onAfterGotoPage:function (evtParam) {
				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		       
				pageNum.current = page; //페이지 번호 저장용 

				//@ts-ignore
				if (currentPage !== -1 && currentPage !== page) {
					makePageIndex(page);
				}
				
			},	
			

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'tb_cfms_refund_req', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터
				
			});
			
			//@ts-ignore
			window.currentPage = -1;
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "환수신청_"+today+".xlsx"});
		},

	}

	//미환수금액 계산 
	function minusFormula(fr) {
		return fr.Row.REDE_AMT - fr.Row.TRD_AMT;
	}

	//환수완려 여부 계산 
	function redeEndFormula(fr) {
		let redeEndYn = "N";
		let redeReqStsCd:string = fr.Row.REDE_REQ_STS_CD;
		if(redeReqStsCd == 'G'){
			redeEndYn = "Y"
		}
		
		return redeEndYn;
	}
		
    async function SetDate(value){
	    const newEndDate = new Date();
	    setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
	    const newStartDate = new Date(newEndDate);
	    newStartDate.setDate(newEndDate.getDate() - value);
	    setStartDate(newStartDate);  // 시작 날짜를 조정
    }
    
    async function onClickSearch(sAction:string, saveSearchData:any) {
		let param = {};
		//검색데이터가 있으면 검색데이터로 처리
		if(saveSearchData != ''){
			param = saveSearchData;
		}else{
			param = {
				"REDE_REQ_DATE_S" : DateUtil.toDateFormat(StartDate, "YYYY-MM-DD"),
				"REDE_REQ_DATE_E" : DateUtil.toDateFormat(EndDate, "YYYY-MM-DD"),
				"REDE_REQ_STS_CD" : redeReqStsCd,
				"REDE_COMPL_YN" : REDE_COMPL_YN,
				"TSK_NM" : TSK_NM,
				"PERSON_NM" : PERSON_NM
			}

			//검색조건을 해당 페이지에 다시 넣어준다.
			searchParams.current = param;
			let searchData = searchParams.current;
			let searchPageNum = 1;   //조회시는 무조건 페이지 번호는 1
			if(receivedData != undefined){
				if(receivedData.searchPageNum == undefined ){
					searchPageNum = 1;
				}else{
					if(receivedData.searchPageNum != '1' ){
						searchPageNum = receivedData.searchPageNum;
					}
				}
			}
			let searchPageType = searchType.current;
			let searchPageRowCnt = rowCnt.current;
			let dataToSend = { searchData , searchPageNum, searchPageType , searchPageRowCnt}
			receivedData = dataToSend;  //검색조건을 다시 넣어준다.
			history.push({ pathname: './adm1500', state: { data: dataToSend }});
		}

		const response:any = await CommonUtil.execute({
            url:"adm_1500_selectList",
            data: param
			
        })
    	.then((response: any) => {
			    		
			let result = response.LIST;

			totalCnt.current = Object.keys(result).length;
			setTotalRowCnt(totalCnt.current);
	
			SheetData = result;
			// @ts-ignore
	        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	        // @ts-ignore
	        sheet.loadSearchData(SheetData);
	        // @ts-ignore
			makePageIndex(sheet.getPageIndex(sheet.getFocusedPage()) + 1); // 페이지 초기화
					
    	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	 
    	
	}


	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			// @ts-ignore
			var sr = sheet.getTotalRowCount(); // 전체 조회 건수
			// @ts-ignore
			var page = sheet.PageLength; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
				
				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}
	
			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";	
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
				
				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
	}
	
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}
	
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);
	}
	
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			defaultRowCnt = e.target.value;
			searchType.current = 'M';
			rowCnt.current = e.target.value;
			setShowRowCnt(rowCnt.current);
			receivedData.searchPageRowCnt = rowCnt.current;

		   	// @ts-ignore
		   	IBSheet.disposeAll(true);		  
		   	ib.init.Cfg.PageLength = e.target.value;
		   	ib.create();
		   
		}else if(e.target.name === 'REDE_COMPL_YN'){
			setREDE_COMPL_YN(e.target.value);
		}
	};

	 //인풋 엔터체크
	 const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch('search','');
		}
	}
		    	
	useEffect(() => {
		codeDataStore.read("[RRSC]").then(()=>{
			if(receivedData != undefined){
				if(receivedData.searchData != undefined){
					if(receivedData.searchData.REDE_REQ_STS_CD != undefined){
						setRedeReqStsCd(StringUtil.defaultString(receivedData.searchData.REDE_REQ_STS_CD));
					}
					if(receivedData.searchData.REDE_COMPL_YN != undefined){
						setREDE_COMPL_YN(StringUtil.defaultString(receivedData.searchData.REDE_COMPL_YN));
						$('#REDE_COMPL_YN').val(receivedData.searchData.REDE_COMPL_YN);
					}
					if(receivedData.searchData.TSK_NM != undefined){
						setTSK_NM(StringUtil.defaultString(receivedData.searchData.TSK_NM));
					}
	
					if(receivedData.searchData.PERSON_NM != undefined){
						setPERSON_NM(StringUtil.defaultString(receivedData.searchData.PERSON_NM));
					}
					if(receivedData.searchData.REDE_REQ_DATE_S != undefined && receivedData.searchData.REDE_REQ_DATE_S !=''){
						const startDate = DateUtil.stringToDate(receivedData.searchData.REDE_REQ_DATE_S,'YYYY-MM-DD');
						setStartDate(startDate!);
					}
	
					if(receivedData.searchData.REDE_REQ_DATE_E != undefined && receivedData.searchData.REDE_REQ_DATE_E != ''){
						const endDate = DateUtil.stringToDate(receivedData.searchData.REDE_REQ_DATE_E,'YYYY-MM-DD');
						setEndDate(endDate!);
					}
				}
	
				if(searchType.current == 'M' || receivedData.searchPageType == 'M'){ //기본보기가 아닐경우 	
					setShowRowCnt(receivedData.searchPageRowCnt);
					rowCnt.current = receivedData.searchPageRowCnt;
					ib.init.Cfg.PageLength = rowCnt.current;
				}	
			}


			// @ts-egnore
			ib.create();

		});
						
        
        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }
    },[])	
    	

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={4}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">환수신청현황</h1>
					<div className="sf sf-fund">
						<div className="inner">
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">신청기간</p>
								<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={StartDate} valueChanged={(value) => setStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={EndDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-item hz-root hz-gap5">		
										<Button color={dateNum == 1 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(90); setDateNum(1); }}>이전 3개월</Button>
										<Button color={dateNum == 2 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(180); setDateNum(2); }}>이전 6개월</Button>
										<Button color={dateNum == 3 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(365); setDateNum(3); }}>이전 12개월</Button>
										<Button color={dateNum == 4 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(730); setDateNum(4); }}>이전 24개월</Button>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">진행상태</p>
								<div className="sf-value">
									<div className="sl sl-md">
										{/* <select>
											<option>전체</option>
											<option>신청</option>
											<option>접수중</option>
											<option>수정요청</option>
											<option>최종접수</option>
											<option>환수완료</option>
										</select> */}
										<UISelect
											value={redeReqStsCd}
											valueChanged={(value) => setRedeReqStsCd(value)}
											codeData={codeDataStore.get("[RRSC]")}
											firstName={"all"}
										/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">환수완료여부</p>
								<div className="sf-value">
									<div className="sl sl-md">
										<select id="REDE_COMPL_YN" name="REDE_COMPL_YN" onChange={handleSelect}>
											<option value="">전체</option>
											<option value="Y">완료</option>
											<option value="N">미완료</option>
										</select>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">과제명</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={TSK_NM} valueChanged={(value) => setTSK_NM(value)} placeholder={'과제명을 입력하세요'} readOnly={false} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">담당자명</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={PERSON_NM} valueChanged={(value) => setPERSON_NM(value)} placeholder={'담당자명을 입력하세요'} readOnly={false} onKeyEnter={(e) => activeEnter(e)}/>	
								</div>
							</div>
						</div>
					</div>
					<div className="hz-root hz-center mb25">
						<Button color="pri" size="md" onClick={() => onClickSearch('search','')}>조회</Button>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black">총 <em className="fw500">{totalRowCnt}</em>건</p>
						</div>
						<div className="hz-root hz-gap5">
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>									
						</div>
					</div>
					<div className="ibsheet" id='tb_cfms_refund_req'></div>
					<div id="pageNavi" className="pg"></div>		
				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;

